// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","fadeIn":"Modal_fadeIn__-PTjN","panel":"Modal_panel__4Hg8X","slideUp":"Modal_slideUp__gG399","closeBtn":"Modal_closeBtn__mlOa4"};